module.exports = __webpack_public_path__ + "static/gofundme-8cbb759847d380da2d1995b9a3692dfd.png";